export default __webpack_public_path__ + "static/media/sideMenu_admin.631412e4.svg";